<template>
  <div 
    :class="`${addTrain ? 'activator-train' : icon ? 'activator-icon' : 'activator'} activator-iceberg`"
    :style="`background-color: ${color}`"
    @mouseover="hover = true"
    @mouseleave="hover = false, add_train_menu = false"
    @click="addTrain?add_train_menu = true:''"
  >
    <div class="activator-iceberg-object">
      <TIcon v-if="icon" :name="icon" color="black" :size="hover ? 24 : 12" />
    </div>
    <div v-if="add_train_menu" class="add-train-menu">
      <div class="add-train-menu-btn"
        @click.prevent.stop="$emit('addTrain'), add_train_menu = false"
        >
        <TText value="choose_sequence" color="black"/>
        </div>
          <div class="add-train-menu-btn"
            @click="add_empty_train = true"
            >
            <div v-if="!add_empty_train">
              <TText value="add_empty_train" color="black"/>
            </div>
          <div v-else class="d-flex">
            <DisableableInputField 
                    label="Waggons" 
                    width="80px"
                    :is_disabled="false" 
                    :value="empty_train_waggon_count"
                    background_color="white" 
                    foreground_color="black"
                    @change="empty_train_waggon_count = parseInt($event)" 
                    />
                    <ButtonOutlined 
                      class="ml-2 black"
                      text="Add"
                      width="50"
                      height="42"
                      style="height: 42px; margin-top: 5px"
                      @buttonClicked="$emit('addEmptyTrain', empty_train_waggon_count)"
                      @click.native.prevent.stop="add_train_menu = false"
                />
        </div>
      </div>
      <div class="add-train-menu-btn"
        @click.prevent.stop="$emit('addBacklog'), add_train_menu = false"
        >
        <TText value="add_backlog" color="black"/>
      </div>
    </div>
  </div>
</template>
<script>
import TIcon from '@/components/Taktify/TIcon.component.vue'
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue'

export default {
  props: ['color', 'addTrain', 'icon'],
  components: {
    TIcon,
    DisableableInputField,
    ButtonOutlined,
  },
  data: () => ({
    hover: false,
    add_train_menu: false,
    add_empty_train: false,
    empty_train_waggon_count: 3,
  }),
}
</script>
<style>
  .activator {
    position: absolute;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    z-index: 2;
    background-color: var(--v-primary-base);
    transition: all 50ms ease-in-out;
  }
  .activator:hover {
    height: 20px;
    width: 20px;
  }
  .activator-icon {
    position: absolute;
    height: 16px;
    width: 16px;
    border-radius: 100%;
    z-index: 2;
    background-color: var(--v-primary-base);
    transition: all 50ms ease-in-out;
  }
  .activator-icon:hover {
    height: 32px;
    width: 32px;
  }
  .activator-train {
    position: absolute;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    z-index: 2;
    background-color: var(--v-primary-base);
    transition: all 50ms ease-in-out;
  }
  .activator-train:hover {
    height: 20px;
    width: 30px;
    border-radius: 100% 5% 5% 5%;
  }
  .activator-iceberg {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .activator-iceberg-object {
    min-width: 30px;
    min-height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .add-train-menu {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 196px;
    padding: 0px 6px 6px 40px;
    z-index: 10;
    cursor: default;
  }
  .add-train-menu-btn {
    white-space: no_wrap;
    background-color: white;
    color: black;
    border-radius: 3px;
    margin-bottom: 6px;
    padding: 6px;
    cursor: pointer;
    user-select: none;
  }
</style>
